import { useState } from 'react';

export default function ShareDialog({ auditId, conceptName, onClose }) {
  const [copied, setCopied] = useState(false);
  const clientUrl = `${window.location.origin}/client/${auditId}`;

  const copyLink = () => {
    navigator.clipboard.writeText(clientUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center px-4" onClick={onClose}>
      <div className="card p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-display text-lg text-white">Share Client Report</h3>
          <button onClick={onClose} className="text-neutral-500 hover:text-white text-xl">x</button>
        </div>

        <label className="label-text">Client View Link</label>
        <div className="flex gap-2">
          <input
            type="text"
            value={clientUrl}
            readOnly
            className="input-field text-sm flex-1 text-neutral-400"
            onClick={(e) => e.target.select()}
          />
          <button onClick={copyLink} className="btn-primary text-xs py-2 whitespace-nowrap min-w-[100px]">
            {copied ? '✓ Copied!' : 'Copy Link'}
          </button>
        </div>
        <p className="text-[10px] text-neutral-600 mt-2">This link is public — anyone with it can view the report</p>
      </div>
    </div>
  );
}
